// extracted by mini-css-extract-plugin
export default {"content":"MainLayout_content__7W1mn","mainContent":"MainLayout_mainContent__PSCOw","hiddenContent":"MainLayout_hiddenContent__aleiO"};